export default __webpack_public_path__ + "static/media/BlackExit.e4ec7113.svg";